import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "pt-0 text-left text-h6 font-weight-light" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_TreeFileView = _resolveComponent("TreeFileView")!
  const _component_PDFView = _resolveComponent("PDFView")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_ctx.finalData)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        class: "d-flex justify-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "2" }),
              _createVNode(_component_v_col, { cols: "8" }, {
                default: _withCtx(() => [
                  _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-h4 font-weight-medium text-center my-2 text-blue-grey-darken-2" }, " Finale Ansicht deiner Präsentation ", -1)),
                  (_ctx.finalData.finalFile)
                    ? (_openBlock(), _createBlock(_component_TreeFileView, {
                        key: 0,
                        zipFile: _ctx.finalData.finalFile,
                        "activate-download": true
                      }, null, 8, ["zipFile"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_sheet, { class: "elevation-5" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_PDFView, {
                        source: _ctx.finalData?.finalPdfSource,
                        page: -1,
                        onLoaded: _ctx.onPdfLoaded
                      }, null, 8, ["source", "onLoaded"]),
                      _createVNode(_component_v_sheet, {
                        height: "auto",
                        "max-height": "700px",
                        class: "pl-2 pr-2 w-auto overflow-y-auto hidden-scrollbar d-flex flex-column align-center bg-blue-grey-lighten-5 elevation-4"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: page,
                              class: "mb-0"
                            }, [
                              _createElementVNode("p", _hoisted_1, _toDisplayString(page), 1),
                              _createVNode(_component_PDFView, {
                                class: "elevation-5 h-auto w-auto",
                                source: _ctx.finalData?.finalPdfSource,
                                page: page,
                                scale: 1.5
                              }, null, 8, ["source", "page"])
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1,
                __: [0]
              }),
              _createVNode(_component_v_col, { cols: "2" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}